export enum CellElementType {
	LABEL,
	WIDGET,
	VALIDATION
}
